import { CustomizationEntry } from "../customizeEntries";

export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_DEBOUNCE_MS = 200;

interface IndexedEntry {
    entry: CustomizationEntry;
    words: string[];
}

const indexCache = new WeakMap<CustomizationEntry[], IndexedEntry[]>();

const toWords = (text: string) => text
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .toLocaleLowerCase()
    .split(/[^a-z0-9%]+/)
    .filter(Boolean);

const getIndex = (entries: CustomizationEntry[]) => {
    let index = indexCache.get(entries);
    if (!index) {
        index = entries.map(entry => ({
            entry,
            words: toWords([entry.displayName, entry.category, entry.subCategory, entry.id].join(' ')),
        }));
        indexCache.set(entries, index);
    }
    return index;
};

export const isSearchActive = (query?: string) => (query || '').trim().length >= MIN_SEARCH_LENGTH;

export const searchEntries = (entries: CustomizationEntry[], query: string): CustomizationEntry[] => {
    const terms = toWords(query);
    if (!terms.length) {
        return [];
    }
    return getIndex(entries)
        .filter(({ words }) => terms.every(term => words.some(word => word.startsWith(term))))
        .map(({ entry }) => entry);
};
